// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuButton_container__2WMmQ","bar1":"MenuButton_bar1__1xebz","bar2":"MenuButton_bar2__xa-xU","bar3":"MenuButton_bar3__3KlUh"};